import moment from "moment";
import "moment/locale/es";

/**
 * Último acceso del aprendiz a partir de users/{uid}.log = [{ timeStamp }],
 * que escribe la app móvil.
 *
 * Firebase puede devolver ese log como arreglo con huecos (null) o como OBJETO
 * (cuando los índices no son correlativos), y algunas entradas pueden venir sin
 * timeStamp. Por eso normalizamos y descartamos lo inválido antes de calcular:
 * si no queda nada usable devolvemos null y el panel muestra "---".
 */
export const lastTime = (data) => {
  moment.locale("es");

  const raw = data?.log;
  if (!raw || typeof raw !== "object") return null;

  const entries = (Array.isArray(raw) ? raw : Object.values(raw)).filter(
    (e) => e && Number(e.timeStamp) > 0
  );
  if (entries.length === 0) return null;

  // La conexión más reciente por timeStamp (no asumimos que sea la última del arreglo).
  const latest = entries.reduce((a, b) =>
    Number(b.timeStamp) > Number(a.timeStamp) ? b : a
  );

  const then = moment.unix(Number(latest.timeStamp));
  if (!then.isValid()) return null;

  return {
    date: then.fromNow(),
    diff: moment().diff(then, "hours"),
    numConn: entries.length,
  };
};
